import { GradeMappingsSchema } from "@redotech/redo-return-settings-common/grade-mapping";
import { processingBillingConfigSchema } from "@redotech/redo-return-settings-common/processing-billing-config";
import {
  receivingDispositionSchema,
  returnsCenterReceivingDispositionsSchema,
} from "@redotech/redo-return-settings-common/receiving-disposition-config";
import { remitModeSchema } from "@redotech/redo-return-settings-common/remit-mode-config";
import {
  returnProcessingLevelSchema,
  returnsCenterProcessingLevelsSchema,
} from "@redotech/redo-return-settings-common/return-processing-level";
import { ReturnsCenterGradeOverridesSchema } from "@redotech/redo-return-settings-common/returns-center-grade-overrides";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const ProtectedSettingsAction = {
  bypassApproval: "bypassApproval",
  requestApproval: "requestApproval",
} as const;
export type ProtectedSettingsAction =
  (typeof ProtectedSettingsAction)[keyof typeof ProtectedSettingsAction];

/** Table-backed managed returns settings. Remaining team-document fields use putTeam. */
export const saveManagedReturnsSettings = unaryRpc({
  name: "saveManagedReturnsSettings" as const,
  input: z.object({
    teamId: z.string(),
    settings: z.object({
      redoManagedReturns: z.any().optional(),
      reFulfillment: z.any().optional(),
    }),
    billing: processingBillingConfigSchema.optional(),
    returnProcessingLevel: returnProcessingLevelSchema.optional(),
    receivingDisposition: receivingDispositionSchema.nullable().optional(),
    gradeMappings: GradeMappingsSchema.optional(),
    remitMode: remitModeSchema.optional(),
    /** Omitted centers keep their overrides; an empty list clears a center's overrides. */
    returnsCenterOverrides: z
      .array(ReturnsCenterGradeOverridesSchema)
      .optional(),
    /** Omitted centers keep their value; null makes a center use the account-wide setting. */
    returnsCenterProcessingLevels:
      returnsCenterProcessingLevelsSchema.optional(),
    returnsCenterReceivingDispositions:
      returnsCenterReceivingDispositionsSchema.optional(),
    protectedSettingsAction: z
      .enum([
        ProtectedSettingsAction.bypassApproval,
        ProtectedSettingsAction.requestApproval,
      ])
      .optional(),
  }),
  output: z.object({ ok: z.literal(true) }),
});
